import { EventEmitter, Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class MessageService {
  constructor() {
    // do nothing
  }
  
  messages = new EventEmitter<any>();
}